import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
    const location = useLocation();

    useEffect(() => {
        // stop the browser from restoring the previous scroll position on reload
        window.history.scrollRestoration = "manual";
        // scroll to top on first load and on every route change
        window.scrollTo(0, 0);
    }, [location]);

    return <>
        {props.children}
    </>
};

export default ScrollToTop;
